import { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface MetricCardProps {
    title: string;
    value: string;
    trend: string;
    isPositive: boolean;
    icon: LucideIcon;
    comparisonText: string;
}

export function MetricCard({
    title,
    value,
    trend,
    isPositive,
    icon: Icon,
    comparisonText,
}: MetricCardProps) {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{title}</CardTitle>
                <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
                <div className="text-2xl font-bold">{value}</div>
                <p className="text-xs text-muted-foreground">
                    <span
                        className={
                            isPositive ? "text-green-500" : "text-red-500"
                        }
                    >
                        {/* {trend} */}
                    </span>{" "}
                    {/* {comparisonText} */}
                </p>
            </CardContent>
        </Card>
    );
}
